export default __webpack_public_path__ + "static/video-preview-1bfe6ffd29069268120ce0ca9020d9d6.png";